class TreatmentProductsCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.333,
          spacing: 10,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2.666,
              spacing: 10,
            },
            disabled: Number(this.dataset.slideCount) <= 3,
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md}px)`]: {
            slides: {
              perView: 3.333,
              spacing: 20,
            },
            disabled: Number(this.dataset.slideCount) <= 3,
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg}px)`]: {
            slides: {
              perView: 2.666,
              spacing: 30,
            },
            disabled: Number(this.dataset.slideCount) <= 3,
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xxlg}px)`]: {
            slides: {
              perView: 3.666,
              spacing: 40,
            },
            disabled: Number(this.dataset.slideCount) <= 3,
          },
        },
      },
      [window.BAO.Carousel.useInitialised()],
    )
  }
}

if (!customElements.get('treatment-products-carousel')) {
  customElements.define(
    'treatment-products-carousel',
    TreatmentProductsCarousel,
  )
}
